'use client';

import { Phone } from '@hc-frontend/core-icons/kit';
import { PhoneCampaign } from '@hc-frontend/core-types';
import { trackExperimentView } from '@hc-frontend/third-party-snowplow';
import { useEffect } from 'react';

import isMobile from '../../../utils/is-mobile';

export function SurveyCallBanner({
  phoneCampaign,
  showSchedule = false,
  experimentFlag,
  experimentTreatment,
}: {
  readonly phoneCampaign: PhoneCampaign;
  readonly showSchedule?: boolean;
  readonly experimentFlag: string;
  readonly experimentTreatment: string | undefined;
}) {
  const { phoneNumber, tty, todayTTY, schedule } = phoneCampaign;
  const phoneNumberAndTty = `${phoneNumber} (${tty})`;

  useEffect(() => {
    if (experimentTreatment && !isMobile()) {
      trackExperimentView({
        experimentName: experimentFlag,
        variantName: experimentTreatment,
        splitSource: 'amplitude',
      });
    }
  }, []);

  const display = !isMobile() && experimentTreatment === 'variant';

  return display ? (
    <div className="bg-secondary-50 text-gray-400 bottom-0 left-0 w-full text-center hidden tablet:block px-12-12 py-8-8">
      <p>Speak with a licensed insurance agent</p>
      <p className="text-tertiary-900">
        <a
          id="survey-call-banner-cta"
          href={phoneCampaign.href}
          data-call-placement={phoneCampaign.placement}
          data-call-product={phoneCampaign.product}
          data-call-phone={phoneCampaign.href}
          data-call-advertiser={phoneCampaign.advertiser}
        >
          <Phone
            data-testid="call-cta-phone"
            className="inline w-[20px] h-[20px] mr-4-4 text-secondary-900"
          />
          <strong>{phoneNumberAndTty}</strong>
        </a>
      </p>
      <p>{showSchedule ? `${schedule} ${todayTTY}` : todayTTY}</p>
    </div>
  ) : null;
}
